import { ref } from 'vue'

export interface QueuedReportExport {
    id: string
    hasAi: boolean
    // Query of the /report page, used to render the report once it is ready
    query: Record<string, string>
}

// Module-level state: exports keep polling while the user moves between pages
const exports = ref<QueuedReportExport[]>([])

export default function useReportExportQueue() {
    const add = (item: QueuedReportExport) => {
        exports.value.push(item)
    }

    const remove = (id: string) => {
        exports.value = exports.value.filter((item) => item.id !== id)
    }

    return {
        exports,
        add,
        remove,
    }
}
